import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import { Setting } from './setting.model';
import { SettingInterface } from './setting.interface';
import { SettingFactory } from './setting.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import 'rxjs/add/observable/throw';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class SettingService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Setting>> {
        return this.http
            .get<SettingInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/settings`, { params, headers: this.authService.headers() })
            .pipe(
                map(data => {
                    const settings = data.map(item => SettingFactory.fromObject(item));
                    if (settings.length > 0) {
                        this.globalService.currentSetting = settings[0];
                    }
                    return settings;
                }),
                catchError(this.errorHandler)
            );
    }

    getSingle(userId: string, groupId: string, id: string): Observable<Setting> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<SettingInterface>(`${environment.apiUrl}/v${environment.apiVersion}/settings/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(setting: Setting): Observable<any> {

        // setting.tabs = _.keyBy(setting.tabs, 'id');

        if (setting.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}`, setting, { headers: this.authService.headers() })
                .pipe(map(item => SettingFactory.fromObject(item)),
                    catchError(this.errorHandler)
                );
        }
    }

    fixForms(setting: Setting): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}/fixforms`, setting, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createUsers(setting: Setting, userId: string, amount: number): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}/createusers`, { userId, amount }, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    deleteUsers(setting: Setting): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}/deleteusers`, setting, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    calculateActivity(setting: Setting): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}/calculate-activity`, setting, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    deleteAllFormData(setting: Setting): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}/deleteallformdata`, setting, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    addRolesToForms(setting: Setting): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/settings/${setting.id}/addrolestoforms`, setting, { headers: this.authService.headers() })
            .pipe(map(item => SettingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    delete(userId: string, groupId: string, id: string): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/settings/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Setting>> {
        return this.http
            .get<SettingInterface[]>(`${this.api}/settings/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawSetting => SettingFactory.fromObject(rawSetting)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/shared/setting.service.ts